const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];
export function gethealthColours(){
  const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

  return DISTINCT
}
export function getHealthConfig() {
  const groupsById = {

    tradeoff_drugs_RnD_vs_costs: {
      type: "likert",
      label: "Trade-off: Pharmaceutical R&D Vs Prices",
      fulltext: "Thinking about just two of the possible implications, “Lowering prescription drug costs for you” and “Reduction of the amount of funding for Research & Development (R&D) into lifesaving new drugs” , which of the following statements do you most agree with?",
      keys:[
          "healthcare_cost:tradeoffcostvrd_noreducerd:lik",
          "healthcare_cost:tradeoffcostvrd_reducerd:lik",
          "healthcare_cost:tradeoffcostvrd_dk:lik"
      ],
       labels:{
          "healthcare_cost:tradeoffcostvrd_noreducerd:lik": "R&D",
          "healthcare_cost:tradeoffcostvrd_reducerd:lik": "Prices",
          "healthcare_cost:tradeoffcostvrd_dk:lik": "Neutral"
      },
    polarity: {
      "pos":"healthcare_cost:tradeoffcostvrd_noreducerd:lik",
      "neg": "healthcare_cost:tradeoffcostvrd_reducerd:lik",
      "neu": "healthcare_cost:tradeoffcostvrd_dk:lik",
    },
    full_labels: {
          "healthcare_cost:tradeoffcostvrd_noreducerd:lik": "Would not accept reduced R&D invesment in exchange for lower prices",
          "healthcare_cost:tradeoffcostvrd_reducerd:lik": "Could accept reductions in R&D investments in exhange for lower prices",
          "healthcare_cost:tradeoffcostvrd_dk:lik": "Neutral"

    },
      schema:"single"

  },

  tradeoff_drugs_access_vs_costs: {
      type: "likert",
      label: "Trade-off: Access to prescriptions Vs Prices",
      fulltext: "Thinking about just two of the possible implications, “Lowering prescription drug costs for you” and “Restricting yours or a loved ones' access to their prescription drugs”, which of the following statements do you most agree with?",
      keys:[
          "healthcare_cost:tradeoffcostvaccess_nolowaccess:lik",
          "healthcare_cost:tradeoffcostvaccess_acceptlowaccess:lik",
          "healthcare_cost:tradeoffcostvaccess_dk:lik"
      ],
       labels:{
          "healthcare_cost:tradeoffcostvaccess_nolowaccess:lik": "Access",
          "healthcare_cost:tradeoffcostvaccess_acceptlowaccess:lik": "Prices",
          "healthcare_cost:tradeoffcostvaccess_dk:lik": "Neutral"
      },
    polarity: {
      "pos":"healthcare_cost:tradeoffcostvaccess_nolowaccess:lik",
      "neg": "healthcare_cost:tradeoffcostvaccess_acceptlowaccess:lik",
      "neu": "healthcare_cost:tradeoffcostvaccess_dk:lik",
    },
    full_labels: {
          "healthcare_cost:tradeoffcostvaccess_nolowaccess:lik": "Would not accept reduced access to prescription drugs in exchange for lower prices",
          "healthcare_cost:tradeoffcostvaccess_acceptlowaccess:lik": "Could accept reduced access to prescription drugs in exhange for lower prices",
          "healthcare_cost:tradeoffcostvaccess_dk:lik": "Neutral"

    },
      schema:"single"

  },
  //   vaccines_effective: {
  //     type: "likert",
  //     label: "Vaccines: Effective",
  //     fulltext: "To what extent do you agree or disagree with the following statements? Overall, I think vaccines are effective ",
  //     keys:[
  //         "healthcare_vaccine:effective_agree:lik",
  //         "healthcare_vaccine:effective_disagree:lik",
  //         "healthcare_vaccine:effective_neutral:lik"
  //     ],
  //      labels:{
  //         "healthcare_vaccine:effective_agree:lik": "Agree",
  //         "healthcare_vaccine:effective_disagree:lik": "Disagree",
  //         "healthcare_vaccine:effective_neutral:lik": "Neutral"
  //     },
  //   polarity: {
  //     "pos": "healthcare_vaccine:effective_agree:lik",
  //     "neg": "healthcare_vaccine:effective_disagree:lik",
  //     "neu": "healthcare_vaccine:effective_neutral:lik",
  //   },
  //     schema:"tracking",
  //     waves:[2,3]

  // },

  // vaccines_safe: {
  //     type: "likert",
  //     label: "Vaccines: Safe",
  //     fulltext: "To what extent do you agree or disagree with the following statements? Overall, I think vaccines are safe ",
  //     keys:[
  //         "healthcare_vaccine:safe_agree:lik",
  //         "healthcare_vaccine:safe_disagree:lik",
  //         "healthcare_vaccine:safe_neutral:lik"
  //     ],
  //      labels:{
  //         "healthcare_vaccine:safe_agree:lik": "Agree",
  //         "healthcare_vaccine:safe_disagree:lik": "Disagree",
  //         "healthcare_vaccine:safe_neutral:lik": "Neutral"
  //     },
  //   polarity: {
  //     "pos": "healthcare_vaccine:safe_agree:lik",
  //     "neg": "healthcare_vaccine:safe_disagree:lik",
  //     "neu": "healthcare_vaccine:safe_neutral:lik",
  //   },
  //     schema:"tracking",
  //     waves:[2,3]

  // }, 
    invest_prevent_outbreaks: {
        type: "likert",
        label: "Should the US invest to prevent future outbreaks",
        fulltext: "To what extent do you agree or disagree with the following statement: 'The U.S. government should invest in preventing and treating diseases in other countries to reduce the risk of future outbreaks spreading to the United States.'",
        keys:[
            "healthcare_internat:investpreventoutbreak_agree:lik",
            "healthcare_internat:investpreventoutbreak_disagree:lik",
            "healthcare_internat:investpreventoutbreak_neither:lik"
        ],
         labels:{
            "healthcare_internat:investpreventoutbreak_agree:lik": "Agree",
            "healthcare_internat:investpreventoutbreak_disagree:lik": "Disagree",
            "healthcare_internat:investpreventoutbreak_neither:lik": "Neutral"
        },
      polarity: {
        "pos":"healthcare_internat:investpreventoutbreak_agree:lik",
        "neu": "healthcare_internat:investpreventoutbreak_neither:lik",
        "neg": "healthcare_internat:investpreventoutbreak_disagree:lik",
      },
      full_labels: {
            "healthcare_internat:investpreventoutbreak_agree:lik": "Agree",
            "healthcare_internat:investpreventoutbreak_disagree:lik": "Disagree",
            "healthcare_internat:investpreventoutbreak_neither:lik": "Neutral"

      },
      schema:"single"

    },



    // international_HIVtreatment: {
    //     type: "likert",
    //     label: "Support for international HIV programmes",
    //     fulltext: "Over the past two decades, U.S. programs to provide HIV/AIDS treatment around the world have helped save millions of lives. To what extent do you support or oppose the U.S. continuing to fund these programs, with the goal of helping to end the global HIV/AIDS epidemic by 2035? ",
    //     keys:[
    //         "healthcare_internat:fundhiv_support:lik",
    //         "healthcare_internat:fundhiv_oppose:lik",
    //         "healthcare_internat:fundhiv_neitherdk:lik"
    //     ],
    //      labels:{
    //         "healthcare_internat:fundhiv_support:lik": "Support",
    //         "healthcare_internat:fundhiv_oppose:lik": "Oppose",
    //         "healthcare_internat:fundhiv_neitherdk:lik": "Neutral"
    //     },
    //   polarity: {
    //     "pos": "healthcare_internat:fundhiv_support:lik",
    //     "neg": "healthcare_internat:fundhiv_oppose:lik",
    //     "neu": "healthcare_internat:fundhiv_neitherdk:lik",
    //   }

    // },


  };

  return { groupsById };
}

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;
  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = (g.labels && g.labels[k]) || k;
      if (!colors[k]) {
        if (g.type === "likert") {
          // Use the special likert color function
          colors[k] = baseColorForLikertKey(g, k);
        } else {
          // Default color assignment
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }
  return { labels, colors };
}

export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

// utils/demoFilters.js (or wherever you keep it)

// Returns a predicate that matches your dataset’s integer-coded fields
export function buildDemoPredicate({
    gender = null,     // 1=Men, 2=Women
    age = null,        // 1=18–34, 2=35–64, 3=65+
    ethnicity = null,  // 1..5
    party = null,      // 1..4
    education = null,  // 1=No degree, 2=Degree
  } = {}) {
    return (r) => {
      // NOTE: r.<field> should be numbers in your data rows
      if (gender != null && Number(r.gender) !== Number(gender)) return false;
      if (age != null && Number(r.age) !== Number(age)) return false;
      if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
      if (party != null && Number(r.party_reg) !== Number(party)) return false;
      if (education != null && Number(r.education) !== Number(education)) return false;
      return true;
    };
  }
  
  // If you want to show labels elsewhere:
  export const GENDER = [
    { value: null, label: "All" },
    { value: 1,    label: "Men" },
    { value: 2,    label: "Women" },
  ];
  
  export const AGE = [
    { value: null, label: "All" },
    { value: 1,    label: "18–34" },
    { value: 2,    label: "35–64" },
    { value: 3,    label: "65+" },
  ];
  
  export const ETHNICITY = [
    { value: null, label: "All" },
    { value: 1,    label: "White" },
    { value: 2,    label: "Black" },
    { value: 3,    label: "Hispanic" },
    { value: 4,    label: "Asian" },
    { value: 5,    label: "Other" },
  ];
  
  export const PARTY = [
    { value: null, label: "All" },
    { value: 1,    label: "Dem" },
    { value: 2,    label: "Rep" },
    { value: 3,    label: "Ind" },
    { value: 4,    label: "None" },
  ];
  
  export const EDU = [
    { value: null, label: "All" },
    { value: 1,    label: "No degree" },
    { value: 2,    label: "Degree" },
  ];
  

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];


  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}

// Tab-as-config default export
export default {
  tab: "healthcare",
  label: "Healthcare",
  get metrics() { return getHealthConfig().groupsById; },
};
